import { useEffect } from "react";

type EffectCallback = () => void | (() => void);

// On web (react-router-dom), components remount on route changes,
// so running the effect on mount + whenever the callback reference
// changes (driven by useCallback's deps) mirrors useFocusEffect semantics.
export const useFocusEffect = (effect: EffectCallback) => {
  useEffect(() => {
    return effect();
  }, [effect]);
};
